import type { ViteImportMeta } from "@/types/config";

const viteEnv = (import.meta as unknown as ViteImportMeta).env ?? {};

export const appConfig = {
  name: "VideoTranscriptSaver",
  shortName: "VideoTranscriptSaver",
  slug: "video-transcript-saver",
  tagline: "Turn videos into transcripts, captions, and notes.",
  description:
    "Upload, record, or paste a video link. Get a transcript, captions, summary, notes, and downloads. No login required.",
  defaultLanguage: "en",
  siteUrl: viteEnv.VITE_PUBLIC_SITE_URL?.replace(/\/$/, "") || "https://videotranscriptsaver.com",
  apiBaseUrl: "/api",
  assets: {
    logo: "/brand-logo.svg",
    mark: "/brand-mark.svg"
  },
  routes: {
    home: "/",
    register: "/register",
    privacy: "/privacy",
    terms: "/terms"
  },
  limits: {
    maxMediaUrlLength: 2048,
    maxUploadMb: 10,
    maxSummaryCharacters: 60000
  }
} as const;
